import React from 'react';
import t from '~t';
import links from '~config/links';
import { useSelector } from 'react-redux';
import { user as getUser } from '~data/selectors/user';

import { Layout, ButtonRow, Separator, Button, Icon } from '~ui';

export default function SharingFooter({
  collection: { public: pub, _id, slug },
}) {
  const user = useSelector((state) => getUser(state));
  const link = `https://${user.name}.raindrop.page/${slug || ''}-${_id}/share`;
  const rss = `https://${user.name}.raindrop.page/${slug || ''}-${_id}/feed`;

  return (
    <Layout>
      <Separator />

      <ButtonRow variant='between'>
        <Button asChild variant='outline'>
          <a
            href={pub ? link : links.help.embed}
            target='_blank'
          >
            <Icon name='dev' />
            Embed
          </a>
        </Button>

        {pub ? (
          <Button asChild variant='outline'>
            <a href={rss} target='_blank'>
              <Icon name='rss' />
              RSS
            </a>
          </Button>
        ) : (
          <Button variant='outline' disabled>
            <Icon name='rss' />
            RSS
          </Button>
        )}

        <div style={{ flex: 1 }} />

        <Button asChild>
          <a href={links.help.publicPage} target='_blank'>
            <Icon name='help' />
            {t.s('howToUse')}
          </a>
        </Button>
      </ButtonRow>
    </Layout>
  );
}
